/* Search overlay (open/close/submit) — externalized + deferred 2026-08-19 (was inline in header.liquid). Liquid-free, interaction-only. */
(function () {
    'use strict';

    var SEARCH_DEBOUNCE_DELAY = 220;
    var MINIMUM_QUERY_LENGTH = 2;
    var controller = null;
    var debounceTimer = null;
    /* This overlay's own last resolved part, kept separate from the desktop panel's. */
    var mobileLastJump = null;

    function getSearchElements() {
      return {
        trigger: document.getElementById('cpSearchTrigger'),
        overlay: document.getElementById('cpSearchOverlay'),
        closeButton: document.getElementById('cpSearchOverlayClose'),
        form: document.getElementById('cpSearchOverlayForm'),
        input: document.getElementById('cpSearchOverlayInput'),
        results: document.getElementById('cpSearchOverlayResults')
      };
    }

    function getSearchUrl(query) {
      var searchPath = (window.routes && window.routes.search_url) ? window.routes.search_url : '/search';
      return searchPath + '?type=product&q=' + encodeURIComponent(query);
    }

    /* The desktop block has cpgEsc; this one had nothing, so what the shopper typed was being
       concatenated straight into innerHTML. Self-inflicted only (your own input, your own browser),
       but there is no reason to build markup out of unescaped input. */
    function cpEsc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function setResults(elements, html, visible) {
      if (!elements.results) return;

      elements.results.innerHTML = html || '';
      elements.results.classList.toggle('is-visible', Boolean(visible));
    }

    function openSearchOverlay(event) {
      var elements = getSearchElements();

      if (!elements.overlay || !elements.input) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      elements.overlay.classList.add('is-open');
      elements.overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cp-search-overlay-open');
      document.body.classList.add('cp-search-overlay-open');

      window.setTimeout(function () {
        elements.input.focus();
      }, 60);
    }

    function closeSearchOverlay(event) {
      var elements = getSearchElements();

      if (!elements.overlay) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      elements.overlay.classList.remove('is-open');
      elements.overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cp-search-overlay-open');
      document.body.classList.remove('cp-search-overlay-open');

      if (controller) {
        controller.abort();
        controller = null;
      }
    }

    /* renderProducts() and formatMoney() lived here and are gone: they decoded the
       /search/suggest.json response shape (featured_image, price_min in cents, product.url), which
       this overlay no longer receives. Rendering is now window.cpgSearch.render, shared with the
       desktop panel. Note they were also the last place in this file interpolating a Shopify title
       and image alt into innerHTML unescaped — that goes away with them. */

    function fetchSearchResults(query) {
      var elements = getSearchElements();

      if (!elements.results) return;

      if (controller) controller.abort();

      if (!query || query.length < MINIMUM_QUERY_LENGTH) {
        setResults(elements, '', false);
        return;
      }

      controller = new AbortController();

      /* Mobile now resolves through OUR classifier, the same one desktop uses, instead of Shopify's
         /search/suggest.json. suggest.json returns a flat product list: it cannot say "this is a
         brand / a category / a part number / a vehicle", which is what a parts shopper actually
         types, and it ships ~7 KB per keystroke because every product carries its full body copy.
         Everything the desktop panel learned — the vehicle/brand/category groups, the part-number
         jump, the fuzzy-model handling that took `yukn` from 4.7 s to 50 ms — was invisible on
         mobile purely because this one call had never been swapped.

         The renderer is shared, not copied (window.cpgSearch, published by the desktop block), so
         the two panels cannot drift apart. If it is ever absent we keep the link-only panel already
         on screen rather than resurrecting suggest.json — same graceful degradation as desktop. */
      var api = window.cpgSearch;
      if (!api) return;

      api.resolve(query, controller.signal)
        .then(function (data) {
          /* This panel owns its OWN jump. The renderer is pure, so mobile and desktop each keep
             their own last-jump and cannot send each other to the wrong product. */
          mobileLastJump = data && data.jump ? data.jump : null;
          setResults(elements, api.render(data, query), true);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          setResults(elements, '<a class="cp-header__search-view-all" href="' + cpEsc(getSearchUrl(query)) + '">Search for “' + cpEsc(query) + '”</a>', true);
        });
    }

    function bindSearchOverlay() {
      var elements = getSearchElements();

      if (!elements.trigger || !elements.overlay || !elements.form || !elements.input) return;
      if (elements.trigger.dataset.cpSearchBound === 'true') return;

      elements.trigger.dataset.cpSearchBound = 'true';

      elements.trigger.addEventListener('click', openSearchOverlay, true);

      elements.trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          openSearchOverlay(event);
        }
      });

      if (elements.closeButton) {
        elements.closeButton.addEventListener('click', closeSearchOverlay, true);
      }

      elements.overlay.addEventListener('click', function (event) {
        if (event.target === elements.overlay) {
          closeSearchOverlay(event);
        }
      });

      elements.form.addEventListener('submit', function (event) {
        var query = elements.input.value.trim();

        if (!query) {
          event.preventDefault();
          elements.input.focus();
          return;
        }

        /* Enter on a resolved part number goes straight to that part, matching desktop. Mobile
           never had this: the desktop handler keys on data-cpg-search-form, which only the desktop
           form carries, so the overlay always fell through to the results page even when we knew
           exactly which part was meant. */
        if (mobileLastJump && mobileLastJump.handle) {
          event.preventDefault();
          window.location.href = '/products/' + mobileLastJump.handle;
        }
      });

      elements.input.addEventListener('input', function () {
        var query = elements.input.value.trim();

        /* The jump dies with the query that produced it — otherwise Enter on a new query sends the
           shopper to the previous query's part. Same defect that was fixed on desktop. */
        mobileLastJump = null;

        window.clearTimeout(debounceTimer);

        /* The clickable link is rendered HERE, not inside fetchSearchResults, because that call is
           debounced by 220 ms. Placed there it was not actually "on the first keystroke" at all —
           the panel sat empty or stale for the whole debounce, which is the exact complaint this
           was meant to fix. Desktop had it right; this one did not. */
        if (query.length >= MINIMUM_QUERY_LENGTH) {
          var els = getSearchElements();
          setResults(
            els,
            '<a class="cp-header__search-view-all" href="' + cpEsc(getSearchUrl(query)) + '">' +
              'Search for “' + cpEsc(query) + '”</a>' +
              '<span class="cp-header__search-result-message">Searching...</span>',
            true
          );
        }

        debounceTimer = window.setTimeout(function () {
          fetchSearchResults(query);
        }, SEARCH_DEBOUNCE_DELAY);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && elements.overlay.classList.contains('is-open')) {
          closeSearchOverlay(event);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindSearchOverlay);
    } else {
      bindSearchOverlay();
    }

    document.addEventListener('shopify:section:load', bindSearchOverlay);
  })();
